import { PropsWithChildren } from "react";
import { Navigate } from "react-router";
import { CircularProgress, Box } from "@mui/material";
import { useUserContext } from "../../hooks/userContext";
import { Pages } from "../../utils";

export const AuthenticatedRoute: React.FC<PropsWithChildren> = ({ children }) => {
  const { user, loading } = useUserContext();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress sx={{ color: "#00A06D" }} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to={Pages.LOGIN} replace />;
  }

  return <>{children}</>;
};
